import { Component, ElementRef, EventEmitter, Input, Output, QueryList, TemplateRef, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs';
import { ChatBotService } from 'src/app/core/services/chat-bot/chat-bot.service';
import { IProjectDetails } from 'src/app/epics/Project/project-dashboard/shared/models/IProjectType';
import { IWorkspace } from 'src/app/epics/Workspace/workspaces-dashboard/shared/models/IWorkSpace';
import { marked } from 'marked';
import {
    Chart,
    TimeScale,
    LinearScale,
    PointElement,
    LineElement,
    LineController,
    Tooltip,
    Legend,
    Filler,
    Title,
    CategoryScale
} from 'chart.js/auto';
import { IUser } from 'src/app/epics/Workspace/workspaces-dashboard/shared/models/IUser';
import 'chartjs-adapter-date-fns';
interface IChatMessage {
    type: 'user' | 'bot' | 'thinking' | 'error';
    message?: string;
    chart?: boolean;
    chartData?: any;          // ✅ RAW chart.js config
    chartInstance?: Chart;   // ✅ actual chart instance
    canvasRef?: HTMLCanvasElement; // ✅ Reference stored per message
    formattedHtml?: SafeHtml;
}



Chart.register(
    TimeScale,   // 🚨 required for time charts
    LinearScale,
    PointElement,
    LineElement,
    LineController,
    Tooltip,
    Legend,
    Filler,
    Title,
    CategoryScale
);

@Component({
    selector: 'app-chat-bot-modal',
    templateUrl: './chat-bot-modal.component.html',
    styleUrl: './chat-bot-modal.component.scss'
})
export class ChatBotModalComponent {

    title: string = 'Fusion AI';
    subTitle: string = 'Turn simple questions into interactive dashboards and visual insights';
    isRequestInProgress: boolean = false;
    userPrompts: string;
    isSendDisabled: boolean = true;
    userInfo: IUser;

    @Input() isModalOpened: boolean = false;
    @Output() hidePopup: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('chatInput') chatInput!: ElementRef<HTMLInputElement>;


    ChartConfig: Chart;


    chatMessages: IChatMessage[] = [];
    Bugsprompts: any = {
        summary: "Can you summarize the bugs data for me?",
        visualization: [
            "Plot a line chart of bugs created month by month.",
            "Create a pie chart for bugs distributed by deviceOS.",
            "Make a doughnut chart showing bugs by trigger source."
        ],
        ai: [] // No prompt yet
    };

    Survaysprompts: any = {
        summary: "Can you summarize the survey responses and key user feedback?",
        visualization: [
            "Plot a line chart showing survey responses collected month by month.",
            "Create a bar chart for average satisfaction score by app version.",
            "Make a pie chart showing feedback distribution by sentiment."
        ],
        ai: [] // No prompt yet
    };

    Crashesprompts: any = {
        summary: "Can you summarize the crash data and highlight the most critical issues?",
        visualization: [
            "Plot a line chart of crashes occurring month by month.",
            "Create a bar chart showing crashes by app version.",
            "Make a pie chart displaying crashes distributed by deviceOS."
        ],
        ai: [] // No prompt yet
    };


    modalTrigger: string;

    private subscription!: Subscription;



    constructor(
        private _chat_bot: ChatBotService,
        private sanitizer: DomSanitizer,
    ) {
        this.userInfo = JSON.parse(localStorage.getItem('currentUser'));
        // this._chat_bot.modalState$.subscribe(state => {
        //     if (state) {
        //         console.log("chat boot open", state);
        //         this.modalTrigger = state.trigger;
        //         if (state.flag && state.trigger == 'crashes') {
        //             this.initilizeCrashSession();
        //         }
        //     }
        // });
    }

    ngOnInit() {
        this.subscription = this._chat_bot.modalState$.subscribe(state => {
            if (state) {
                console.log("chat boot open", state);
                this.modalTrigger = state.trigger;
                if (state.flag && state.trigger == 'crashes') {
                    this.initilizeCrashSession();
                }
            }
        });
    }

    initilizeCrashSession(): void {
        const body = {
            workspace_kuid: (JSON.parse(localStorage.getItem('lastVisited_workspace')) as IWorkspace).ws_kuid,
            project_kuid: (JSON.parse(localStorage.getItem('selectedProject')) as IProjectDetails).p_kuid,
        };
        this._chat_bot.createSessionCrash(body)
            .subscribe((res) => {
                console.log("res", res);
            }, (err) => {
                console.log("error", err);
            });
    }


    // scroll to bottom of chat container reliably
    private getChatContainer(): HTMLElement | null {
        // Prefer querying within your modal to be scoped and safe
        // '.ccm-permission-dialogue .chat_board' targets the chat_board inside your modal
        return (document.querySelector('.ccm-permission-dialogue .chat_board') as HTMLElement) || null;
    }

    private scrollToBottomOnce() {
        const container = this.getChatContainer();
        if (!container) return;
        // use requestAnimationFrame to wait until browser paints
        requestAnimationFrame(() => {
            container.scrollTo({
                top: container.scrollHeight,
                behavior: 'smooth'
            });
        });
    }

    handleButtonClick(type: string) {

        // 🚫 Prevent multiple clicks
        if (this.isRequestInProgress) return;

        // ✅ If AI button clicked (no prompt), just focus input
        if (type === 'ai') {
            setTimeout(() => {
                this.chatInput?.nativeElement.focus();
            }, 0);
            return;
        }




        let prompt;

        switch (this.modalTrigger) {
            case 'bugs':
                prompt = this.Bugsprompts[type]; // select the prompt for bugs

                break;
            case 'surveys':
                prompt = this.Survaysprompts[type]; // select the prompt for surveys
                console.log("survey operation");
                break;
            case 'crashes':
                prompt = this.Crashesprompts[type];
                console.log("crashes");
                break;
            default:
                console.log("not trigger");
        }

        // Now you can use the prompt variable
        console.log("Selected prompt:", prompt);

        if (!prompt || (Array.isArray(prompt) && prompt.length === 0)) return;

        const selectedPrompt = Array.isArray(prompt)
            ? prompt[Math.floor(Math.random() * prompt.length)]
            : prompt;

        this.addUserMessage(selectedPrompt);
    }

    handleSendButton(): void {
        if (this.isSendDisabled) return;


        this.addUserMessage(this.userPrompts.trim());

        // ✅ Clear input after sending
        this.userPrompts = '';
        this.isSendDisabled = true;


    }

    onPromptChange() {
        const isEmptyOrSpaces = !this.userPrompts || this.userPrompts.trim().length === 0;

        this.isSendDisabled = isEmptyOrSpaces || this.isRequestInProgress;
    }

    addUserMessage(userText: string) {

        // ✅ LOCK BUTTONS
        this.isRequestInProgress = true;

        const formatted = this.sanitizer.bypassSecurityTrustHtml(
            `<span>${userText}</span>`
        );

        this.chatMessages.push({ type: 'user', formattedHtml: formatted });



        switch (this.modalTrigger) {
            case 'bugs':
                this.bugOperation(userText);
                break;
            case 'surveys':
                console.log("survay operation");
                this.survayOperation(userText);
                break;
            case 'crashes':
                console.log("crashes");
                this.crashesOperation(userText);
                break;
            default:
                console.log("not trigger");
        }
    }

    bugOperation(userText: string): void {

        const thinkingIndex = this.chatMessages.push({ type: 'thinking' }) - 1;

        setTimeout(() => { this.scrollToBottomOnce(); }, 0);
        const body = {
            prompt: userText,
            workspaceKuid: (JSON.parse(localStorage.getItem('lastVisited_workspace')) as IWorkspace).ws_kuid,
            projectKuid: (JSON.parse(localStorage.getItem('selectedProject')) as IProjectDetails).p_kuid,
        };

        this.getBotResponse(body).subscribe((botResponse) => {


            // console.log(botResponse);

            this.chatMessages.splice(thinkingIndex, 1);


            if (botResponse.status) {
                const rawHtml = marked(botResponse.data.Answer, { gfm: true, breaks: true });
                const formatted = this.sanitizer.bypassSecurityTrustHtml(`<div>${rawHtml}</div>`);


                this.chatMessages.push({
                    type: 'bot',
                    formattedHtml: formatted,
                    chart: !!botResponse.data.chart_data,
                    chartData: botResponse.data.chart_data   // ✅ STORE chart data here
                });
            } else {

                this.chatMessages.push({
                    type: 'error',
                    formattedHtml: this.sanitizer.bypassSecurityTrustHtml(
                        `<span>${botResponse?.message?.description}</span>`
                    )
                });
            }


            this.userPrompts = null;
            this.isRequestInProgress = false;

            // ✅ Wait for DOM to render, THEN draw charts
            setTimeout(() => { this.renderCharts(); this.scrollToBottomOnce(); }, 0);

        }, (err) => {


            console.log("error=>>", err);

            this.chatMessages.splice(thinkingIndex, 1);

            this.chatMessages.push({
                type: 'error',
                formattedHtml: this.sanitizer.bypassSecurityTrustHtml(
                    `<span>${err?.message?.description}</span>`
                )
            });

            this.isRequestInProgress = false;

            setTimeout(() => { this.scrollToBottomOnce(); }, 0);
        });
    }



    survayOperation(userText: string): void {

        const thinkingIndex = this.chatMessages.push({ type: 'thinking' }) - 1;

        setTimeout(() => { this.scrollToBottomOnce(); }, 0);
        const body = {
            prompt: userText,
            workspaceKuid: (JSON.parse(localStorage.getItem('lastVisited_workspace')) as IWorkspace).ws_kuid,
            projectKuid: (JSON.parse(localStorage.getItem('selectedProject')) as IProjectDetails).p_kuid,
        };

        this.getServayBotResponse(body).subscribe((botResponse) => {


            // console.log(botResponse);

            this.chatMessages.splice(thinkingIndex, 1);


            if (botResponse.status) {
                const rawHtml = marked(botResponse.data.Answer, { gfm: true, breaks: true });
                const formatted = this.sanitizer.bypassSecurityTrustHtml(`<div>${rawHtml}</div>`);


                this.chatMessages.push({
                    type: 'bot',
                    formattedHtml: formatted,
                    chart: !!botResponse.data.chart_data,
                    chartData: botResponse.data.chart_data   // ✅ STORE chart data here
                });
            } else {

                this.chatMessages.push({
                    type: 'error',
                    formattedHtml: this.sanitizer.bypassSecurityTrustHtml(
                        `<span>${botResponse?.message?.description}</span>`
                    )
                });
            }


            this.userPrompts = null;
            this.isRequestInProgress = false;

            // ✅ Wait for DOM to render, THEN draw charts
            setTimeout(() => { this.renderCharts(); this.scrollToBottomOnce(); }, 0);

        }, (err) => {


            console.log("error=>>", err);

            this.chatMessages.splice(thinkingIndex, 1);

            this.chatMessages.push({
                type: 'error',
                formattedHtml: this.sanitizer.bypassSecurityTrustHtml(
                    `<span>${err?.message?.description}</span>`
                )
            });

            this.isRequestInProgress = false;

            setTimeout(() => { this.scrollToBottomOnce(); }, 0);
        });
    }

    crashesOperation(userText: string): void {

        const thinkingIndex = this.chatMessages.push({ type: 'thinking' }) - 1;

        setTimeout(() => { this.scrollToBottomOnce(); }, 0);
        const body = {
            prompt: userText,
            workspaceKuid: (JSON.parse(localStorage.getItem('lastVisited_workspace')) as IWorkspace).ws_kuid,
            projectKuid: (JSON.parse(localStorage.getItem('selectedProject')) as IProjectDetails).p_kuid,
        };

        this.getCrashesBotResponse(body).subscribe((botResponse) => {


            // console.log(botResponse);

            this.chatMessages.splice(thinkingIndex, 1);


            if (botResponse.status) {
                const rawHtml = marked(botResponse.data.Answer, { gfm: true, breaks: true });
                const formatted = this.sanitizer.bypassSecurityTrustHtml(`<div>${rawHtml}</div>`);


                this.chatMessages.push({
                    type: 'bot',
                    formattedHtml: formatted,
                    chart: !!botResponse.data.chart_data,
                    chartData: botResponse.data.chart_data   // ✅ STORE chart data here
                });
            } else {

                this.chatMessages.push({
                    type: 'error',
                    formattedHtml: this.sanitizer.bypassSecurityTrustHtml(
                        `<span>${botResponse?.message?.description}</span>`
                    )
                });
            }


            this.userPrompts = null;
            this.isRequestInProgress = false;

            // ✅ Wait for DOM to render, THEN draw charts
            setTimeout(() => { this.renderCharts(); this.scrollToBottomOnce(); }, 0);

        }, (err) => {


            console.log("error=>>", err);

            this.chatMessages.splice(thinkingIndex, 1);

            this.chatMessages.push({
                type: 'error',
                formattedHtml: this.sanitizer.bypassSecurityTrustHtml(
                    `<span>${err?.message?.description}</span>`
                )
            });

            this.isRequestInProgress = false;

            setTimeout(() => { this.scrollToBottomOnce(); }, 0);
        });
    }


    fixDateFormat(format: string) {
        return format
            .replace(/YYYY/g, 'yyyy')
            .replace(/YY/g, 'yy')
            .replace(/DD/g, 'dd');
    }

    renderCharts() {

        let chartIndex = 0;


        this.chatMessages.forEach((msg, index) => {
            if (msg.chart && msg.chartData && !msg.chartInstance) {
                const canvasRef = document.getElementById('chart-' + index) as HTMLCanvasElement;;
                if (!canvasRef) return;

                // store canvas reference per message
                msg.canvasRef = canvasRef;

                try {
                    // ✅ ensure date parsing works cleanly

                    const hasAdapter = !!(Chart as any)._adapters?._date;
                    const xScale = msg.chartData?.options?.scales?.x;

                    // Fix date format tokens
                    if (xScale?.time) {
                        if (xScale.time.tooltipFormat) {
                            xScale.time.tooltipFormat = this.fixDateFormat(xScale.time.tooltipFormat);
                        }

                        if (xScale.time.displayFormats) {
                            Object.keys(xScale.time.displayFormats).forEach(key => {
                                xScale.time.displayFormats[key] =
                                    this.fixDateFormat(xScale.time.displayFormats[key]);
                            });
                        }
                    }

                    // Handle time scale safely
                    if (xScale?.type === 'time') {
                        if (hasAdapter) {
                            msg.chartData.data.labels =
                                msg.chartData.data.labels.map((d: string) => new Date(d));
                        } else {
                            xScale.type = 'category';
                            delete xScale.time;
                        }
                    }

                    console.log("Creating chart with data:", msg.chartData?.options?.scales?.x?.type);
                    // create chart only once
                    msg.chartInstance = new Chart(canvasRef, {
                        type: msg.chartData.type,
                        data: msg.chartData.data,
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            ...(msg.chartData.options || {})
                        },
                        plugins: msg.chartData.plugins || []
                    });

                } catch (error) {
                    console.error("Error creating chart:", error);
                }

                chartIndex++;
            }
        });
    }



    // Simulated async bot response
    getBotResponse(body: any): Observable<any> {
        return this._chat_bot.sendMessageToBot(body);
    };

    getServayBotResponse(body: any): Observable<any> {
        return this._chat_bot.sendMessageToSurvayBot(body);
    };

    getCrashesBotResponse(body: any): Observable<any> {
        return this._chat_bot.sendMessageToCrashesBot(body);
    };


    /**
     * Closes the license generation modal.
     */
    closeDialog(): void {
        this.isModalOpened = false;
        this.hidePopup.emit(false);
    };

    ngOnDestroy(): void {
        this.chatMessages.forEach(msg => {
            if (msg.chartInstance) {
                msg.chartInstance.destroy();
            }
        });

        this.subscription.unsubscribe();
    }
}
